module.exports = __webpack_public_path__ + "img/teams-logo-2.d5752aa3.png";